import React, { useState, useContext, useEffect } from "react";
import App from "./App";
import axios from 'axios'

const AppContext = React.createContext()

const allMealsUrl = 'https://themealdb.com/api/json/v1/1/search.php?s='
const randomMealUrl = 'https://themealdb.com/api/json/v1/1/random.php'

function getFavoritesFromLocalStorage() {
  let favorites = localStorage.getItem('favorites')
  
  // if (favorites) {
  //   favorites = JSON.parse(localStorage.getItem('favorites'))
  // } else {
  //   favorites = []
  // }

  favorites
  ? favorites = JSON.parse(localStorage.getItem('favorites'))
  : favorites = []

  return favorites
}

function AppProvider ({children}) {

  const [loading, setLoading] = useState(false)
  const [meals, setMeals] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [selectedMeal, setSelectedMeal] = useState(null)
  const [favorites, setFavorites] = useState(getFavoritesFromLocalStorage())

  // async function fetchData () {
  //   try {
  //     const response = await fetch('https://randomuser.me/api/')
  //     const data = await response.json()
  //     console.log(data)
  //   } catch(error) {
  //     console.log(error)
  //   }
  // }

  async function fetchMeals(url) {
    setLoading(true)
    try {
      const response = await axios(url)
      response.data.meals ? setMeals(response.data.meals) : setMeals([])
    } catch (error) {
      console.log(error.response)
    }
    setLoading(false)
  }

  function selectMeal(idMeal, favoriteMeal) {
    let meal
    if (favoriteMeal) {
      meal = favorites.find((meal)=>meal.idMeal===idMeal)
    } else {
      meal = meals.find((meal)=>meal.idMeal===idMeal)
    }
    setSelectedMeal(meal)
    setShowModal(true)
  }

  function fetchRandomMeal() {
    fetchMeals(randomMealUrl)
  }

  function closeModal() {
    setShowModal(false)
  }

  function addToFavorites(idMeal) {
    const meal = meals.find((meal) => meal.idMeal === idMeal)
    const alreadyFavorite = favorites.find((meal) => meal.idMeal === idMeal)
    if (alreadyFavorite) return
    const updatedFavorites = [...favorites, meal]
    setFavorites(updatedFavorites)
    localStorage.setItem('favorites', JSON.stringify(updatedFavorites))
  }

  function removeFromFavorites(idMeal) {
    const updatedFavorites = favorites.filter((meal) => meal.idMeal !==idMeal)
    setFavorites(updatedFavorites)
    localStorage.setItem('favorites', JSON.stringify(updatedFavorites))
  }

  useEffect(() => {
    fetchMeals(allMealsUrl)
  }, [])

  useEffect(() => {
    if (!searchTerm) return 
    fetchMeals(`${allMealsUrl}${searchTerm}`)
  }, [searchTerm])

  return (
    <AppContext.Provider
      value={{
        loading,
        meals,
        setSearchTerm,
        fetchRandomMeal,
        showModal,
        selectedMeal,
        selectMeal,
        closeModal,
        addToFavorites,
        removeFromFavorites,
        favorites
      }}
    >
        {children}
    </AppContext.Provider>
  )
}

export function useGlobalContext() {
  return useContext(AppContext)
}

export { AppContext, AppProvider }